import { Primary, PrimaryDark } from './Palettes/index.js';
export const palette = {
    primary: Primary,
    primaryDark: PrimaryDark,
};
